import axios from '@/utils/axios'


export function postApiLogin(params) {
	return axios({
		url: 'api/login',
		method: 'POST',
		data: params
	})
}

export function postApiLogout() {
	return axios({
		url: 'api/logout',
		method: 'POST'
	})
}